<template>
  <v-dialog
    v-model="viewDetailStatus"
    width="800px"
    transition="dialog-top-transition"
  >
    <v-card>
      <v-toolbar flat class="header" dark dense>
        <v-icon>mdi-account-box</v-icon>
        <span class="ml-3">Card User Details</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="viewDetailStatusclose()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-tabs
        dense
        :vertical="!isMobile"
        align="left"
        class="my-tabs"
        :height="!isMobile ? '240px' : '54px'"
        v-model="tab"
      >
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-circle-slice-8</v-icon
          >User Details
        </v-tab>

        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-circle-slice-8</v-icon
          >Expense Approver
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-circle-slice-8</v-icon
          >Budget
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-circle-slice-8</v-icon
          >Card Details
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-circle-slice-8</v-icon
          >User Type Details
        </v-tab>
        <!-- <v-tab>Other Information</v-tab> -->
        <v-tab-item>
          <v-card elevation="1" shaped class="ml-9 mb-10 mt-9" width="500">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Full Name</b>
                      </span>
                      <br />
                      <span class="caption">
                        {{ itemsVaue.first_name }}
                        {{ itemsVaue.middle_name }}
                        {{ itemsVaue.last_name }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Mobile Number</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemsVaue.phone_number != null"
                      >
                        {{ itemsVaue.phone_number }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Email-Id</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemsVaue.email_id != null">
                        {{ itemsVaue.email_id }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Designation</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemsVaue.designation != null"
                      >
                        {{ itemsVaue.designation }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-row class="mt-3 ml-3 mr-1">
            <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
              <v-card width="auto" height="auto" class="pt-2 mb-8" shaped>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approver 1</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver1.approver_name }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Email</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver1.approver_email }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-for="(dep, key) in approverdep"
                      :key="key"
                    >
                      {{
                        dep.dep_name != undefined
                          ? approverdep.length - 1 != approverdep.indexOf(dep)
                            ? dep.dep_name + ", "
                            : dep.dep_name + "."
                          : "-"
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
              <v-card width="auto" height="auto" class="pt-2" shaped>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Approver 2</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver2.approver_name }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Email</b>
                    </span>
                    <br />
                    <span class="caption">
                      {{ approver2.approver_email }}
                    </span>
                  </v-col>
                </v-row>
                <v-row class="ml-0">
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Department Name</b>
                    </span>
                    <br />
                    <span class="caption">
                      <span
                        class="caption"
                        v-for="(dep, key) in approverdep2"
                        :key="key"
                      >
                        {{
                          dep.dep_name != undefined
                            ? approverdep2.length - 1 !=
                              approverdep2.indexOf(dep)
                              ? dep.dep_name + ", "
                              : dep.dep_name + "."
                            : "-"
                        }}
                      </span>
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-card elevation="1" shaped class="ml-9 mb-10 mt-9">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Department Name </b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="userbudget.user_department != null"
                      >
                        {{ userbudget.user_department }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">User Budget (MYR)</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="userbudget.user_budget != null"
                      >
                        {{ userbudget.user_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>

                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Email-Id</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemsVaue.email_id != null">
                        {{ itemsVaue.email_id }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Department Budget (MYR)</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="userbudget.department_budget != null"
                      >
                        {{ userbudget.department_budget }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card elevation="1" shaped class="ml-9 mb-10 mt-9">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Type</b>
                      </span>
                      <br />
                      <span class="caption" v-if="carddetails.card_type == 1">
                        Non Personalized Card
                      </span>
                      <span class="caption" v-if="carddetails.card_type == 2">
                        Personalized Card
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Sub Card Type</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="carddetails.sub_card_type == 1"
                      >
                        Physical Card
                      </span>
                      <span
                        class="caption"
                        v-if="carddetails.sub_card_type == 2"
                      >
                        Virtual Card
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="carddetails.card_name != null"
                      >
                        {{ carddetails.card_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Card Description</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="carddetails.card_description != null"
                      >
                        {{ carddetails.card_description }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card elevation="1" shaped class="ml-9 mb-10 mt-9" width="500">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">User Type Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemUsers.user_type_name != null"
                      >
                        {{ itemUsers.user_type_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Role Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemUsers.role_name != null">
                        {{ itemUsers.role_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Grade Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="itemUsers.grade_name != null">
                        {{ itemUsers.grade_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Loaction Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="itemUsers.location_name != null"
                      >
                        {{ itemUsers.location_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
export default {
  props: {
    approver1: Object,
    approver2: Object,
    userbudget: Object,
    carddetails: Object,
    itemUsers: Object,
  },
  data: () => ({
    first_cardinfo: {},
    registered_address: "",
    business_address: "",
    itemsVaue: {},
    tab: 0,
    depNew: "",
    depNew2: "",
    approverdep: [],
    approverdep2: [],
    viewDetailStatus: false,
    fileList: [],
    docheaders: [
      { text: "SL NO", value: "sl_no" },
      { text: "DOC", value: "doc_url" },
      { text: "DOC NAME", value: "doc_name" },
    ],
    keyContactheaders: [
      { text: "NAME", value: "name" },
      { text: "EMAIL", value: "email_id" },
      { text: "MOBILE", value: "mobile_no" },
      { text: "SIGNATURE", value: "signature_url" },
    ],
    addressSelection: "registered_address",
    bankitems: [],
    bankheaders: [
      { text: "ACCT TYPE", value: "account_type" },
      { text: "ACCT NAME", value: "account_name" },
      { text: "BANK NAME", value: "bank_name" },
      { text: "ACCT NO", value: "bank_account_num" },
    ],
    Department: [],
    Department2: [],
  }),
  watch: {
    approver1(val) {
      this.Department = val;
      // this.approverdep = JSON.parse(this.Department.approver_department);
      this.approverdep = this.Department.approver_department;
    },
    approver2(val) {
      this.Department2 = val;
      // this.approverdep = JSON.parse(this.Department.approver_department);
      this.approverdep2 = this.Department2.approver_department;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    convertDate(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    viewDetailStatusclose() {
      this.viewDetailStatus = false;
      this.tab = 0;
    },
  },
};
</script>
<style scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
.tab1 {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
</style>
